<template>
  <section class="custom-adas-map">
    <div v-if="modelValue" class="custom-body">
      <div class="col custom-header mb-3">
        <h5 class="mb-0">Broken Link # {{ reportedLink.adasBrokenLink }} - {{ reportedLink.source }}</h5>
      </div>
      <z-tabs :model-value="currentTab" :tabs="tabs" @change="showTab" />
      <!-- General Info -->
      <div v-show="currentTab === 'General Info'" class="custom-tab-panel">
        <div class="row border custom-info-row mb-3">
          <div class="custom-info-title">General Info</div>
          <div class="row custom-info-row">
            <div class="col-5"><i class="fas fa-clipboard-check fa-fw custom-info-icon"></i>Adas Inspection</div>
            <div class="col-7 custom-info-value">{{ modelValue.adasInspection }}</div>
          </div>
          <div class="row custom-info-row">
            <div class="col-5"><i class="fas fa-table fa-fw custom-info-icon"></i>Adas Matrix Vehicle</div>
            <div class="col-7 custom-info-value">{{ modelValue.adasChecklistMatrixVehicle }}</div>
          </div>
          <div class="row custom-info-row">
            <div class="col-5"><i class="fas fa-mouse-pointer fa-fw custom-info-icon"></i>Clicks</div>
            <div class="col-7 custom-info-value">{{ totalClicks }}</div>
          </div>
          <div class="row custom-info-row">
            <div class="col-5"><i class="fas fa-calendar-alt fa-fw custom-info-icon"></i>Reason</div>
            <div class="col-7 custom-info-value" :class="getStatus(reportedLink, 'reportedStatus').class">
              {{ getStatus(reportedLink, 'reportedStatus').name }}
            </div>
          </div>
          <div class="row custom-info-row">
            <div class="col-5"><i class="fas fa-calendar-alt fa-fw custom-info-icon"></i>Status</div>
            <div class="col-7 custom-info-value" :class="getStatus(reportedLink).class">{{ getStatus(reportedLink).name }}</div>
          </div>
          <div v-if="resolvedDate" class="row custom-info-row">
            <div class="col-5"><i class="fas fa-calendar-alt fa-fw custom-info-icon"></i>Resolved Date</div>
            <div class="col-7 custom-info-value">{{ resolvedDate }}</div>
          </div>
        </div>
        <!-- Vehicle Info -->
        <div class="row border custom-info-row  mb-3">
          <div class="custom-info-title">Reported Vehicle Info</div>
          <div class="row custom-info-row">
            <div class="col-5"><i class="fas fa-car-side fa-fw custom-info-icon"></i>Make</div>
            <div class="col-7 custom-info-value">{{ modelValue.vehicleMakeName }}</div>
          </div>
          <div class="row custom-info-row">
            <div class="col-5"><i class="fas fa-car fa-fw custom-info-icon"></i>Model</div>
            <div class="col-7 custom-info-value">{{ modelValue.vehicleModel }}</div>
          </div>
          <div class="row custom-info-row">
            <div class="col-5"><i class="fas fa-calendar-alt fa-fw custom-info-icon"></i>Year</div>
            <div class="col-7 custom-info-value">{{ modelValue.vehicleYear }}</div>
          </div>
        </div>
        <!-- Matrix Info -->
        <div class="row border custom-info-row">
          <div class="custom-info-title">Matrix Info</div>
          <div class="row custom-info-row">
            <div class="col-5"><i class="fas fa-car-side fa-fw custom-info-icon"></i>Make</div>
            <div class="col-7 custom-info-value">{{ modelValue.vehicleMakeName }}</div>
          </div>
          <div class="row custom-info-row">
            <div class="col-5"><i class="fas fa-car fa-fw custom-info-icon"></i>Matrix Model</div>
            <div class="col-7 custom-info-value">{{ modelValue.matrixModel }}</div>
          </div>
          <div class="row custom-info-row">
            <div class="col-5"><i class="fas fa-calendar-alt fa-fw custom-info-icon"></i>Matrix Years</div>
            <div class="col-7 custom-info-value">{{ yearRange }}</div>
          </div>
          <div class="row custom-info-row">
            <div class="col-5"><i class="fas fa-tags fa-fw custom-info-icon"></i>Adas Category</div>
            <div class="col-7 custom-info-value">{{ modelValue.adasCategory }}</div>
          </div>
          <div class="row custom-info-row">
            <div class="col-5"><i class="fas fa-microchip fa-fw custom-info-icon"></i>System</div>
            <div class="col-7 custom-info-value">{{ modelValue.system }}</div>
          </div>
          <div class="row custom-info-row">
            <div class="col-5"><i class="fas fa-puzzle-piece fa-fw custom-info-icon"></i>Calibration</div>
            <div class="col-7 custom-info-value">{{ modelValue.calibration }}</div>
          </div>
          <div class="row custom-info-row">
            <div class="col-5"><i class="fas fa-map-marker-alt fa-fw custom-info-icon"></i>Location</div>
            <div class="col-7 custom-info-value">{{ modelValue.location }}</div>
          </div>
          <div class="row custom-info-row">
            <div class="col-5"><i class="fas fa-info-circle fa-fw custom-info-icon"></i>Link Info ID</div>
            <div class="col-7 custom-info-value">{{ reportedLink.adasLinks }}</div>
          </div>
        </div>
      </div>
      <!-- Reported Broken Link -->
      <div v-show="currentTab === 'Reported Broken Link'" class="custom-tab-panel">
        <!-- The row covers a whole calibration, so it can stand for several reported links.
             Pick which one to repair; the save still targets that link's own record. -->
        <div v-if="hasSeveralLinks" class="row mb-3">
          <div class="col">
            <div class="input-group">
              <span class="input-group-text">Selected Reported Link</span>
              <select class="form-control" :value="activeLinkId" @change="selectLink($event.target.value)">
                <option v-for="member in links" :key="member.adasBrokenLink" :value="member.adasBrokenLink">
                  #{{ member.adasBrokenLink }} - {{ member.display || member.url }} ({{ getStatus(member).name }})
                </option>
              </select>
            </div>
          </div>
        </div>
        <div v-if="isNoLinkBuilt" class="row">
          <div class="col">
            <div class="alert alert-info mb-0">No link has been built for this vehicle. Go to the <strong>Related Links</strong> tab to add new link.</div>
          </div>
        </div>
        <div v-else>
          <!-- Current Link -->
          <div class="row">
            <div class="col">
              <h6>Customer reported broken link</h6>
              <div class="input-group">
                <span class="input-group-text">Document Title</span>
                <input v-model="documentTitle" type="text" class="form-control" :readonly="isReadOnly" />
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col">
              <div class="input-group">
                <span class="input-group-text">Broken Url</span>
                <input :value="reportedLink.url" type="text" class="form-control" readonly />
                <a
                  v-if="reportedLink.url"
                  class="btn btn-outline-secondary"
                  :href="reportedLink.url"
                  title="open link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i class="fa fa-external-link-alt"></i>
                </a>
              </div>
            </div>
          </div>
          <!-- Replacement Link -->
          <div class="row mt-5">
            <div class="col">
              <h6 class="mt-1">
                Choose a replacement link for the reported link
                <span>(<span class="text-danger">* Select the link that best matches the link title above.</span>)</span>
                <a
                  v-if="!isReadOnly && !isNoLinkFound"
                  href="#"
                  class="custom-refresh"
                  title="Get the latest replacement links from ALLDATA"
                  @click.prevent="refreshReplacementLinks"
                >
                  <i class="fas fa-sync-alt" :class="{ 'fa-spin': isLoadingReplacements }"></i>
                </a>
              </h6>
              <div v-if="isLoadingReplacements" class="row mt-3">
                <div class="col text-center"><i class="fas fa-spinner fa-spin"></i></div>
              </div>
              <template v-else>
                <div v-if="!hasSuggestions" class="row mt-3">
                  <div class="col text-center">No replacement links found.</div>
                </div>
                <div
                  v-for="(link, index) in replacementLinks"
                  :key="index"
                  class="row border m-2"
                  :class="{ 'custom-selected-link': link.isSelected }"
                >
                  <div class="col">
                    <div class="row custom-collapse-header" @click="toggleLink(index)">
                      <div class="col">
                        <i class="fa" :class="isExpanded(index) ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                        <span class="ms-2">{{ link.article }}</span>
                        <span v-if="!link.isCustom" class="ms-2" style="color: green">Relevance score: {{ link.relevance || 0 }}</span>
                      </div>
                      <div class="col-auto custom-replace-check d-flex align-items-center" @click.stop>
                        <button
                          v-if="link.article && !link.isCustom"
                          type="button"
                          class="btn btn-link btn-sm p-0 me-3 custom-copy"
                          title="Copy Title"
                          @click="copyToClipboard(link.article, index, 'title')"
                        >
                          <span v-if="isCopied(index, 'title')" class="custom-copied">
                            <i class="fas fa-check"></i>
                            <span class="ms-1">Copied!</span>
                          </span>
                          <span v-else><i class="far fa-copy"></i></span>
                        </button>
                        <div class="form-check mb-0">
                          <input
                            :id="`replace-${index}`"
                            :checked="link.isSelected"
                            type="checkbox"
                            class="form-check-input"
                            :disabled="isReadOnly"
                            @change="toggleSelected(index)"
                          />
                          <label :for="`replace-${index}`" class="form-check-label"></label>
                        </div>
                      </div>
                    </div>
                    <div v-show="isExpanded(index)">
                      <div class="row mt-2">
                        <div class="col">
                          <div class="input-group mb-2">
                            <span class="input-group-text">{{ link.isCustom ? 'CUSTOM URL:' : 'API SELF HREF:' }}</span>
                            <input
                              :value="link.url"
                              type="text"
                              class="form-control"
                              :readonly="isReadOnly || !link.isCustom"
                              :placeholder="link.isCustom ? 'Enter a replacement url' : ''"
                              @input="linkUrlChanged(link, $event.target.value)"
                            />
                            <button
                              v-if="link.url"
                              type="button"
                              class="btn btn-outline-secondary"
                              title="Copy Url"
                              @click="copyToClipboard(link.url, index, 'url')"
                            >
                              <span v-if="isCopied(index, 'url')" class="custom-copied">
                                <i class="fas fa-check"></i>
                                <span class="ms-1">Copied!</span>
                              </span>
                              <span v-else><i class="far fa-copy"></i></span>
                            </button>
                            <a v-if="link.url" class="btn btn-outline-secondary" :href="link.url" title="open link" target="_blank">
                              <i class="fa fa-external-link-alt"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div v-if="!link.isCustom" class="row mt-2 mb-2">
                        <div class="col">
                          <div class="input-group">
                            <span class="input-group-text"># of Clicks:</span>
                            <span class="form-control">{{ link.clickCount || 0 }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <!-- Related Links -->
      <div v-show="currentTab === 'Related Links'" class="custom-tab-panel">
        <repair-link-related-links
          :model="reportedLink"
          :groups="adasLink"
          :read-only="isReadOnly"
          :numb-of-search-results="maxReplacementLinks"
          @change="relatedLinksChanged"
        />
      </div>
    </div>
    <div v-if="modelValue && showActions" class="row custom-action-bar align-items-center">
      <div class="col">
        <z-message v-model="message" class="alert alert-warning mb-0" />
      </div>
      <div v-if="!isReadOnly" class="col-auto">
        <button type="button" class="btn btn-primary" :class="{ 'btn-danger': isHighlight }" :disabled="!hasChanges" @click="save()">
          Save
        </button>
        <button
          type="button"
          class="btn btn-primary ms-2"
          :class="{ 'btn-danger': isHighlight }"
          :disabled="!hasChanges"
          @click="save({ close: true })"
        >
          Save &amp; Close
        </button>
        <button type="button" class="btn btn-primary ms-2" :class="{ 'btn-danger': isHighlight }" @click="save({ isResolved: true })">
          Resolve
        </button>
      </div>
    </div>

    <confirm-action
      v-model="showDiscardConfirm"
      confirm-title="Unsaved Changes"
      confirm-action="Discard"
      confirm-question="There are unsaved changes. Are you sure to close without saving them?"
      cancel-action="Keep Editing"
      @closing="cancelClose"
      @proceed="confirmClose"
    />
  </section>
</template>
<script>
import { mapActions } from 'pinia'
import { adasmatrixStore } from '@/stores/adasmatrix'
import ZTabs from '@/components/utilities/elements/Tabs.vue'
import ZMessage from '@/components/utilities/elements/Message.vue'
import ConfirmAction from '@/components/utilities/elements/ConfirmDialog.vue'
import RepairLinkRelatedLinks from '@/components/adasmatrix/repair-link-related-links.vue'
import { buildAlternateLinks, buildLinkGroups, parseLink, isNoLinkBuiltOrFound, BrokenLinkStatus, getBrokenLinkStatus } from '@/plugins/broken-link-helper'
import globals from '@/plugins/globals'
import moment from 'moment'
import _ from 'lodash'

const MAX_REPLACEMENT_LINKS = 5
const DEFAULT_TAB = 'General Info'
// what a save can change on a report. The save answers with the bare report row, so its
// vehicle and matrix fields come back empty and must not be copied over
const SAVED_FIELDS = ['adasLinks', 'status', 'reportedStatus', 'newDisplay', 'suggestionsData', 'lastUpdateDate', 'resolvedDate']

function buildCustomLink() {
  return {
    article: 'Other',
    url: '',
    isCustom: true,
    isSelected: false
  }
}

export default {
  name: 'RepairLinkAdasMapDetail',
  components: {
    ZTabs,
    ZMessage,
    ConfirmAction,
    RepairLinkRelatedLinks
  },
  props: {
    modelValue: Object
  },
  emits: ['closing', 'saved', 'state-change', 'update:modelValue'],
  data() {
    return {
      message: null,
      isHighlight: false,
      expandedLinks: [],
      selectedLink: null,
      originalSelectedLink: null,
      originalCustomUrl: '',
      currentTab: DEFAULT_TAB,
      tabs: [DEFAULT_TAB, 'Reported Broken Link', 'Related Links'],
      documentTitle: '',
      replacementLinks: [],
      // ADAS Map's no-results placeholders - never shown or picked, but they hold the report's
      // hit count, so they are kept aside and written back on save
      reportMarkers: [],
      isLoadingReplacements: false,
      // the related links tab reports its own edited titles / picked replacements up to here
      relatedLinkChanges: [],
      isReadOnly: false,
      showDiscardConfirm: false,
      isNoLinkBuilt: false,
      isNoLinkFound: false,
      activeLink: null,
      // which copy button just copied, so it can show "Copied!" for a moment
      copied: null,
      copiedTimer: null
    }
  },
  watch: {
    modelValue: {
      handler(value, previous) {
        const previousId = this.activeLink ? this.activeLink.adasBrokenLink : previous ? previous.adasBrokenLink : null
        const members = value && Array.isArray(value.members) ? value.members : []
        this.activeLink = this.activeLink
          ? members.find((x) => String(x.adasBrokenLink) === String(this.activeLink.adasBrokenLink)) || null
          : null
        const currentId = this.activeLink ? this.activeLink.adasBrokenLink : value ? value.adasBrokenLink : null
        // same link as before means this was a save, not a new row, so leave the tab alone
        this.applyLink(previousId !== null && String(previousId) === String(currentId))
      },
      immediate: true
    },
    shellState: {
      handler(value) {
        this.$emit('state-change', value)
      },
      immediate: true
    }
  },
  computed: {
    links() {
      return this.modelValue && Array.isArray(this.modelValue.members) ? this.modelValue.members : []
    },
    hasSeveralLinks() {
      return this.links.length > 1
    },
    reportedLink() {
      if (!this.modelValue) {
        return null
      }
      return this.activeLink ? { ...this.modelValue, ...this.activeLink } : this.modelValue
    },
    activeLinkId() {
      return this.reportedLink ? this.reportedLink.adasBrokenLink : null
    },
    maxReplacementLinks() {
      return MAX_REPLACEMENT_LINKS
    },
    showActions() {
      return this.currentTab !== DEFAULT_TAB
    },
    shellState() {
      return {
        hasChanges: this.hasChanges,
        isReadOnly: this.isReadOnly,
        message: this.message,
        isHighlight: this.isHighlight,
        id: this.id,
        showActions: this.showActions
      }
    },
    id() {
      let _data = null
      if (this.reportedLink) {
        _data = `# ${this.reportedLink.adasBrokenLink} - ${this.reportedLink.source}`
      }
      return _data
    },
    yearRange() {
      if (!this.modelValue) {
        return ''
      }
      let start = this.modelValue.yearStart
      let end = this.modelValue.yearEnd
      if (!start && !end) {
        return ''
      }
      if (start === end) {
        return `${start}`
      }
      return `${start} - ${end}`
    },
    resolvedDate() {
      if (!this.reportedLink || this.reportedLink.status !== BrokenLinkStatus.Resolved || !this.reportedLink.resolvedDate) {
        return ''
      }
      return moment(this.reportedLink.resolvedDate).format('MM/DD/YYYY')
    },
    totalClicks() {
      return [...this.replacementLinks, ...this.reportMarkers].reduce((total, link) => total + (link.clickCount || 0), 0)
    },
    hasSuggestions() {
      return this.replacementLinks.some((x) => !x.isCustom)
    },
    customLink() {
      return this.replacementLinks.find((x) => x.isCustom) || null
    },
    customUrl() {
      return this.customLink ? String(this.customLink.url || '').trim() : ''
    },
    hasChanges() {
      return (
        this.selectedLink !== this.originalSelectedLink ||
        this.customUrl !== this.originalCustomUrl ||
        this.relatedLinkChanges.length > 0 ||
        (this.reportedLink && this.documentTitle && this.documentTitle.trim() !== this.reportedLink.newDisplay)
      )
    },
    brokenLinkUrls() {
      if (!this.reportedLink || !this.reportedLink.suggestionsData) {
        return []
      }
      return this.replacementLinks.map((x) => x.url).filter((x) => x !== null && x !== undefined && x !== '')
    },
    adasLink() {
      if (!this.modelValue) {
        return []
      }
      let builtLinks = buildLinkGroups(this.modelValue.allData)
      let links = []
      builtLinks.forEach((group) => {
        // the links already reported as broken are handled on the other tab
        let remaining = (group.links || []).filter((x) => String(this.reportedLink.url || '').indexOf(x.url) === -1)
        if (remaining.length) {
          links.push({
            ...group,
            links: remaining
          })
        }
      })
      return links
    }
  },
  methods: {
    ...mapActions(adasmatrixStore, ['getLinksByTypeAndSearchTerm', 'saveBrokenLink']),
    applyLink(keepTab = false) {
      let value = this.reportedLink
      this.expandedLinks = []
      this.selectedLink = null
      this.originalSelectedLink = null
      this.originalCustomUrl = ''
      this.relatedLinkChanges = []
      this.showDiscardConfirm = false
      this.message = null
      if (!keepTab) {
        this.currentTab = DEFAULT_TAB
      }
      this.documentTitle = value && value.newDisplay ? value.newDisplay : ''
      this.isReadOnly = !!(value && value.status === BrokenLinkStatus.Resolved)
      this.isNoLinkBuilt = !!(value && value.reportedStatus === BrokenLinkStatus.NoLinkBuilt)
      this.isNoLinkFound = !!(value && value.reportedStatus === BrokenLinkStatus.NoLinksFound)
      this.loadReplacementLinks()
    },
    selectLink(adasBrokenLink) {
      let picked = this.links.find((x) => String(x.adasBrokenLink) === String(adasBrokenLink))
      if (!picked || picked.adasBrokenLink === this.activeLinkId) {
        return
      }
      if (!this.isReadOnly && this.hasChanges) {
        this.message = 'Save or cancel your changes before switching to another reported link.'
        return
      }
      this.activeLink = picked
      this.applyLink(true)
    },
    showTab(tab) {
      this.currentTab = tab
    },
    close() {
      if (!this.isReadOnly && this.hasChanges) {
        this.showDiscardConfirm = true
        return
      }
      this.confirmClose()
    },
    requestClose() {
      this.close()
    },
    cancelClose() {
      this.showDiscardConfirm = false
    },
    confirmClose() {
      this.showDiscardConfirm = false
      this.isHighlight = false
      this.$emit('closing')
    },
    isExpanded(index) {
      return this.expandedLinks.indexOf(index) !== -1
    },
    toggleLink(index) {
      let position = this.expandedLinks.indexOf(index)
      if (position === -1) {
        this.expandedLinks.push(index)
      } else {
        this.expandedLinks.splice(position, 1)
      }
    },
    toggleSelected(index) {
      // only one replacement link can be selected at a time
      this.selectedLink = this.selectedLink === index ? null : index
      this.replacementLinks.forEach((link, position) => {
        link.isSelected = this.selectedLink === position
      })
      // picking "Other" is only useful with its url in view
      let selected = this.replacementLinks[this.selectedLink]
      if (selected && selected.isCustom && !this.isExpanded(this.selectedLink)) {
        this.toggleLink(this.selectedLink)
      }
    },
    linkUrlChanged(link, value) {
      link.url = value
    },
    async copyToClipboard(text, index, type) {
      if (!text) {
        return
      }
      try {
        await navigator.clipboard.writeText(text)
        this.copied = { index, type }
        clearTimeout(this.copiedTimer)
        this.copiedTimer = setTimeout(() => {
          this.copied = null
        }, 1500)
      } catch {
        this.message = 'Could not copy to clipboard.'
      }
    },
    isCopied(index, type) {
      return !!this.copied && this.copied.index === index && this.copied.type === type
    },
    relatedLinksChanged(changes) {
      this.relatedLinkChanges = changes
    },
    async loadReplacementLinks() {
      this.replacementLinks = []
      this.reportMarkers = []
      if (!this.reportedLink) {
        this.isLoadingReplacements = false
        return
      }
      if (!this.reportedLink.suggestionsData) {
        this.applyReplacementLinks([])
        this.originalSelectedLink = this.selectedLink
        this.originalCustomUrl = this.customUrl
        this.isLoadingReplacements = false
        return
      }
      this.isLoadingReplacements = true
      let requested = this.reportedLink
      let links = await this.getAllDataLinks()
      if (this.reportedLink !== requested) {
        return
      }
      this.applyReplacementLinks(links)
      this.originalSelectedLink = this.selectedLink
      this.originalCustomUrl = this.customUrl
      this.isLoadingReplacements = false
    },
    async refreshReplacementLinks() {
      if (this.isLoadingReplacements || this.isReadOnly || !this.reportedLink) {
        return
      }
      this.isLoadingReplacements = true
      this.message = null
      let custom = this.customLink
      let stored = _.keyBy(
        this.replacementLinks.filter((x) => x.url && !x.isCustom),
        'url'
      )
      this.replacementLinks = []
      this.expandedLinks = []
      this.selectedLink = null
      let requested = this.reportedLink
      let links = await this.getAllDataLinks(true)
      if (this.reportedLink !== requested) {
        return
      }
      links = links.map((s) => ({
        ...s,
        clickCount: stored[s.url] ? stored[s.url].clickCount : 0,
        lastClickedDate: stored[s.url] ? stored[s.url].lastClickedDate : null,
        adasBrokenLink: stored[s.url] ? stored[s.url].adasBrokenLink : null
      }))
      this.applyReplacementLinks(custom ? [...links, custom] : links)
      this.isLoadingReplacements = false
    },
    applyReplacementLinks(links) {
      // markers already set aside stay as they are, e.g. across a refresh
      let markers = links.filter((x) => isNoLinkBuiltOrFound(x)).map((x) => ({ ...x, isSelected: false }))
      if (markers.length) {
        this.reportMarkers = markers
      }
      this.replacementLinks = this.withCustomLink(links.filter((x) => !isNoLinkBuiltOrFound(x)))
      // a suggestion stored as selected drives the checkbox, so track it here too
      let selected = this.replacementLinks.findIndex((x) => x.isSelected)
      this.selectedLink = selected === -1 ? null : selected
    },
    withCustomLink(links) {
      let custom = links.find((x) => x.isCustom) || buildCustomLink()
      return [...links.filter((x) => !x.isCustom), custom]
    },
    async getAllDataLinks(getLatest = false) {
      if (!getLatest && this.reportedLink && this.reportedLink.suggestionsData) {
        let links = []
        try {
          let suggestions = JSON.parse(this.reportedLink.suggestionsData)
          if (Array.isArray(suggestions) && suggestions.length > 0) {
            links = suggestions
          }
        } catch {
          links = []
        }
        return links
      } else {
        let search = parseLink(this.reportedLink, true)
        try {
          let results = await this.getLinksByTypeAndSearchTerm({
            source: this.reportedLink.source,
            carid: search.carid,
            searchTerm: search.searchTerm,
            itype: search.itype
          })
          // the links already reported as broken are not replacements
          return buildAlternateLinks(results)
            .filter((s) => this.brokenLinkUrls.indexOf(s.url) === -1)
            .slice(0, MAX_REPLACEMENT_LINKS)
        } catch {
          return []
        }
      }
    },
    async save(options = {}) {
      const isResolved = options.isResolved === true
      const closeView = options.close === true
      let valid = true
      this.message = null
      if (!isResolved && !this.hasChanges) {
        valid = false
        this.isHighlight = true
        this.message = 'Select the link to replace.'
      }
      let selected = this.replacementLinks[this.selectedLink]
      if (valid && selected && selected.isCustom && !this.customUrl) {
        valid = false
        this.isHighlight = true
        this.message = 'Enter a url for the Other replacement link.'
      }
      if (valid) {
        this.isHighlight = false
        if (selected && selected.isCustom) {
          selected.url = this.customUrl
        }

        // the related links tab keeps this current as the admin edits titles / picks replacements
        let linksToUpdate = this.relatedLinkChanges

        try {
          let payload = {
            adasBrokenLink: this.reportedLink.adasBrokenLink,
            adasLinks: this.reportedLink.adasLinks,
            adasInspection: this.reportedLink.adasInspection,
            adasChecklistMatrixVehicle: this.reportedLink.adasChecklistMatrixVehicle,
            categoryId: this.reportedLink.categoryId,
            categoryName: this.reportedLink.categoryName,
            url: this.reportedLink.url,
            // carried through untouched - the save rewrites these columns on the reporting side
            system: this.reportedLink.system,
            location: this.reportedLink.location,
            calibration: this.reportedLink.calibration,
            display: this.reportedLink.display,
            newDisplay: this.documentTitle.trim(),
            suggestionsData: JSON.stringify([...this.replacementLinks, ...this.reportMarkers]),
            reportedStatus: this.reportedLink.reportedStatus,
            status: isResolved ? BrokenLinkStatus.Resolved : BrokenLinkStatus.UnderReview,
            createdOn: this.reportedLink.createdOn,
            lastUpdateDate: this.reportedLink.lastUpdateDate,
            relatedLinks: linksToUpdate,
            source: this.reportedLink.source
          }

          let results = this.parseSavedData(await this.saveBrokenLink(payload))
          if (results && results.error) {
            this.isHighlight = true
            this.message = results.error
            return
          }
          this.$emit('saved', payload)

          if (closeView) {
            this.confirmClose()
            return
          }
          this.applySaved(results || payload)
        } catch (e) {
          this.message = e && e.message ? e.message : 'The Repair Link could not be saved.'
        }
      }
    },
    parseSavedData(value) {
      if (!value) {
        return null
      }
      if (typeof value === 'object') {
        return value
      }
      return globals.isJson(value) ? JSON.parse(value) : null
    },
    applySaved(data) {
      const saved = _.pick(data, SAVED_FIELDS)
      const members = this.links.map((x) => (String(x.adasBrokenLink) === String(data.adasBrokenLink) ? { ...x, ...saved } : x))
      this.$emit('update:modelValue', { ...this.modelValue, ...saved, members: members })
    },
    showMessage(message) {
      this.message = message
    },
    getStatus(data, type = '') {
      return getBrokenLinkStatus(type === '' ? data.status : data.reportedStatus)
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-adas-map {
  width: 100%;
}
.custom-body {
  overflow-x: hidden;
}
.custom-info-title {
  font-weight: 600;
  padding: 0.375rem 0.75rem;
}
.custom-info-row {
  margin: 0;
}
.custom-info-row + .custom-info-row {
  border-top: 1px solid #dee2e6;
}
.custom-info-row > div {
  padding: 0.375rem 0.75rem;
  word-break: break-word;
}
.custom-info-icon {
  color: #6c757d;
  margin-right: 0.5rem;
}
.custom-tab-panel {
  padding-top: 1rem;
  margin: 10px;
}
// outside the scrolling body, so Save and Resolve stay put however long the tab is
.custom-action-bar {
  border-top: 1px solid #dee2e6;
  margin: 0;
  padding-top: 0.75rem;
  margin-top: 0.5rem;
}
.custom-collapse-header {
  cursor: pointer;
  padding: 0.5rem 0;
  user-select: none;
}
.custom-replace-check {
  cursor: default;
  white-space: nowrap;
}
.custom-replace-check .form-check-label {
  cursor: pointer;
}
.custom-selected-link {
  background-color: #e4f5df;
}
.custom-refresh {
  color: #6c757d;
  margin-left: 0.5rem;
  cursor: pointer;
}
.custom-refresh:hover {
  color: #0d6efd;
}
.custom-copy {
  color: #6c757d;
}
.custom-copy:hover {
  color: #0d6efd;
}
.custom-copied {
  font-size: 0.8rem;
  font-weight: 500;
  color: #198754;
}
.custom-header {
  align-items: center;
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 0.5rem;
}
</style>
